import React from 'react';

const SvgIncentiveSmall = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <circle cx={10} cy={10} r={10} fill="#FE544A" />
    <path
      fill="#FFE6AA"
      d="M13.34 10.92a2.42 2.42 0 110 4.83 2.42 2.42 0 010-4.83M13 5.94A.75.75 0 0114.06 7l-7.07 7.07a.75.75 0 11-1.06-1.06zm.34 6.48a.92.92 0 100 1.83.92.92 0 000-1.83M6.67 4.25a2.42 2.42 0 110 4.83 2.42 2.42 0 010-4.83m0 1.5a.92.92 0 100 1.83.92.92 0 000-1.83"
    />
  </svg>
);

export default SvgIncentiveSmall;
